import { useContext } from "react";

import { OrganisationContext } from "../components/organisation-provider";

export const useOrganisation = () => {
  const context = useContext(OrganisationContext);

  if (!context || !context.organisation) {
    throw new Error(
      "useOrganisation must be used within a OrganisationProvider",
    );
  }

  return context;
};
